const GA_ID = 'G-LEP97KNGRF';
const GOOGLE_ADS_ID = 'AW-18030637586';
const CONTACT_FORM_CONVERSION_SEND_TO = 'AW-18030637586/1vkACNGB4ZEcEJLk1pVD';

function attachGtagReportConversion() {
  if (typeof window === 'undefined') return;
  window.gtag_report_conversion = function gtag_report_conversion(url) {
    if (typeof window.gtag !== 'function') {
      if (typeof url !== 'undefined') window.location = url;
      return false;
    }
    try {
      if (localStorage.getItem('cookieChoice') !== 'accepted') {
        if (typeof url !== 'undefined') window.location = url;
        return false;
      }
    } catch {
      if (typeof url !== 'undefined') window.location = url;
      return false;
    }
    const callback = function () {
      if (typeof url !== 'undefined') {
        window.location = url;
      }
    };
    window.gtag('event', 'conversion', {
      send_to: CONTACT_FORM_CONVERSION_SEND_TO,
      event_callback: callback
    });
    return false;
  };
}

export function loadGtag() {
  if (typeof window === 'undefined' || window.__gtagInjected) return;
  window.__gtagInjected = true;

  const s = document.createElement('script');
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  s.async = true;
  s.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID);
    gtag('config', GOOGLE_ADS_ID);
    attachGtagReportConversion();
  };
  document.head.appendChild(s);
}

function runContactConversion() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'conversion', { send_to: CONTACT_FORM_CONVERSION_SEND_TO });
}

export function reportContactFormConversion() {
  if (typeof window === 'undefined') return;
  try {
    if (localStorage.getItem('cookieChoice') !== 'accepted') return;
  } catch {
    return;
  }
  if (typeof window.gtag === 'function') {
    runContactConversion();
    return;
  }
  loadGtag();
  const start = Date.now();
  const id = window.setInterval(() => {
    if (typeof window.gtag === 'function') {
      window.clearInterval(id);
      runContactConversion();
    } else if (Date.now() - start > 12000) {
      window.clearInterval(id);
    }
  }, 50);
}

export function scheduleGtagIfConsented() {
  try {
    if (localStorage.getItem('cookieChoice') !== 'accepted') return;
  } catch {
    return;
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => loadGtag(), { timeout: 4000 });
  } else {
    window.addEventListener('load', () => setTimeout(loadGtag, 2000), { once: true });
  }
}
